import Immutable from 'immutable';
import React from 'react';
import PropTypes from 'prop-types';
import {
  PortalCourseLinksPropType,
  PortalInstitutionPropType,
} from '../../../CustomPropTypes/PortalPropTypes';
import { PortalNavBar } from './PortalNavBar';
import { PortalMobileNavBar } from './PortalMobileNavBar';
import { noop } from '../../utilities/functions';

export class PortalTopBar extends React.PureComponent {
  static displayName = 'PortalTopBar';

  static propTypes = {
    portalInstitution: PortalInstitutionPropType.isRequired,
    links: PortalCourseLinksPropType,
    callToAction: PropTypes.string,
    onCallToAction: PropTypes.func,
    pageReady: PropTypes.bool,
    showMobileNavBar: PropTypes.bool,
  };

  static defaultProps = {
    links: Immutable.List(),
    callToAction: '',
    onCallToAction: noop,
    pageReady: false,
    showMobileNavBar: false,
  };

  render() {
    const { showMobileNavBar } = this.props;
    return (
      <div className="portal-nav-bar">
        {showMobileNavBar ? (
          <PortalMobileNavBar {...this.props} />
        ) : (
          <PortalNavBar {...this.props} />
        )}
      </div>
    );
  }
}
